var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: _vm.operateMaps[_vm.operate] || "-",
          backUrl: "/marketing/draw/activity",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "list-tabs",
              model: {
                value: _vm.currentTab,
                callback: function ($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab",
              },
            },
            _vm._l(_vm.headTab, function (item, index) {
              return _c("el-tab-pane", {
                key: index,
                attrs: { label: item.tit, name: item.name },
              })
            }),
            1
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "formValidate",
              staticClass: "formValidate form-boder-padding",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "108px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "1",
                      expression: "currentTab === '1'",
                    },
                  ],
                  attrs: { gutter: 24 },
                },
                [
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid, false),
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "活动名称：", prop: "activityName" },
                        },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              maxlength: "100",
                              "show-word-limit": "",
                              placeholder: "请输入活动名称",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.activityName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "activityName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.activityName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "活动样式：", prop: "activityStyle" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "from-ipt-width",
                              attrs: {
                                disabled: _vm.isDisabled || _vm.isEdit,
                                size: "small",
                                placeholder: "请选择",
                              },
                              on: { change: _vm.changeStyle },
                              model: {
                                value: _vm.formValidate.activityStyle,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formValidate,
                                    "activityStyle",
                                    $$v
                                  )
                                },
                                expression: "formValidate.activityStyle",
                              },
                            },
                            _vm._l(_vm.styleOptions, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.label,
                                  value: item.value,
                                  disabled: item.disabled,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动时间：", prop: "drawTime" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              size: "small",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "default-time": ["00:00:00", "23:59:59"],
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "picker-options": _vm.pickerOptions,
                              disabled: _vm.isDisabled,
                              align: "right",
                            },
                            model: {
                              value: _vm.formValidate.drawTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "drawTime", $$v)
                              },
                              expression: "formValidate.drawTime",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动说明：", prop: "remark" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "500px" } },
                            [
                              !_vm.isDisabled
                                ? _c("Tinymce", {
                                    model: {
                                      value: _vm.formValidate.remark,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formValidate,
                                          "remark",
                                          $$v
                                        )
                                      },
                                      expression: "formValidate.remark",
                                    },
                                  })
                                : _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.formValidate.remark
                                      ),
                                    },
                                  }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "活动背景图：",
                            prop: "activityBackPic",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox acea-row",
                              on: { click: _vm.modalPicTap },
                            },
                            [
                              _vm.formValidate.activityBackPic
                                ? _c("div", { staticClass: "pictrue" }, [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.formValidate.activityBackPic,
                                      },
                                    }),
                                  ])
                                : _c("div", { staticClass: "upLoad" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-camera cameraIconfont",
                                    }),
                                  ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isDisabled,
                                  expression: "!isDisabled",
                                },
                              ],
                              staticClass: "from-tips",
                            },
                            [_vm._v("建议尺寸：750*2495px，上传小于1mb的图片")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "2",
                      expression: "currentTab === '2'",
                    },
                  ],
                  attrs: { gutter: 24 },
                },
                [
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "参与条件：", prop: "joinType" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "from-ipt-width",
                              attrs: {
                                disabled: _vm.isDisabled,
                                size: "small",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.formValidate.joinType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formValidate, "joinType", $$v)
                                },
                                expression: "formValidate.joinType",
                              },
                            },
                            _vm._l(_vm.joinTypeOptions, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.formValidate.joinType === 2
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "消耗积分：",
                                prop: "joinCostPoints",
                              },
                            },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  min: 1,
                                  step: 1,
                                  disabled: _vm.isDisabled,
                                  "controls-position": "right",
                                  "step-strictly": "",
                                  placeholder: "请输入消耗积分",
                                },
                                model: {
                                  value: _vm.formValidate.joinCostPoints,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formValidate,
                                      "joinCostPoints",
                                      $$v
                                    )
                                  },
                                  expression: "formValidate.joinCostPoints",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: "抽奖机会：", prop: "dailyLimit" } },
                        [
                          _c(
                            "el-select",
                            { attrs: { value: 1, size: "small" } },
                            [
                              _c("el-option", {
                                attrs: { label: "每人每日抽奖次数", value: 1 },
                              }),
                            ],
                            1
                          ),
                          _c("el-input-number", {
                            attrs: {
                              min: 1,
                              step: 1,
                              disabled: _vm.isDisabled,
                              "controls-position": "right",
                              "step-strictly": "",
                              placeholder: "请输入抽奖次数",
                            },
                            model: {
                              value: _vm.formValidate.dailyLimit,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "dailyLimit", $$v)
                              },
                              expression: "formValidate.dailyLimit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "3",
                      expression: "currentTab === '3'",
                    },
                  ],
                  attrs: { gutter: 24 },
                },
                [
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid, false),
                    [
                      !_vm.isDisabled
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                disabled:
                                  _vm.formValidate.prizeSaveRequest.length >=
                                  _vm.maxPrizeLength,
                              },
                              on: { click: _vm.addPrizeItem },
                            },
                            [_vm._v(" 添加奖项 ")]
                          )
                        : _vm._e(),
                      _c(
                        "el-tabs",
                        {
                          staticClass: "mt14",
                          attrs: { type: "border-card" },
                          on: { "tab-remove": _vm.removePrizeItem },
                          model: {
                            value: _vm.prizeTab,
                            callback: function ($$v) {
                              _vm.prizeTab = $$v
                            },
                            expression: "prizeTab",
                          },
                        },
                        _vm._l(
                          _vm.formValidate.prizeSaveRequest,
                          function (item, index) {
                            return _c(
                              "el-tab-pane",
                              {
                                key: index,
                                attrs: {
                                  label:
                                    item.prizeType === 99
                                      ? "谢谢参与"
                                      : "奖项" + (index + 1),
                                  name: index.toString(),
                                  closable:
                                    !_vm.isDisabled &&
                                    index !== 0 &&
                                    item.prizeType !== 99 &&
                                    _vm.prizeRemovable,
                                },
                              },
                              [
                                _c("prize-item", {
                                  attrs: {
                                    value: item,
                                    disabled: _vm.isDisabled,
                                    winProbability:
                                      _vm.prizeWinProbabilityTotal,
                                  },
                                }),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  Number(_vm.currentTab) > 1
                    ? _c(
                        "el-button",
                        {
                          staticClass: "submission priamry_border",
                          on: { click: _vm.handleSubmitUp },
                        },
                        [_vm._v("上一步")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: Number(_vm.currentTab) < _vm.headTab.length,
                          expression: "Number(currentTab) < headTab.length",
                        },
                      ],
                      staticClass: "priamry_border",
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmitNest("formValidate")
                        },
                      },
                    },
                    [_vm._v("下一步")]
                  ),
                  _vm.checkPermi([
                    "platform:lottery:activity:save",
                    "platform:lottery:activity:update",
                  ])
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (_vm.currentTab === "3" ||
                                  _vm.$route.params.id) &&
                                !_vm.isDisabled,
                              expression:
                                "(currentTab === '3' || $route.params.id) && !isDisabled",
                            },
                          ],
                          staticClass: "submission",
                          attrs: { type: "primary", loading: _vm.loadingBtn },
                          on: {
                            click: function ($event) {
                              return _vm.handleSubmit("formValidate")
                            },
                          },
                        },
                        [_vm._v("保存")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }